import React, { useState } from 'react'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import TextInput from '../inputs/text-input'
import SelectInput from '../inputs/select-input'
import PhoneInputWrapper from '../inputs/phone-input'
import DateSelect from '../inputs/date-select'
import MultiSelect from '../inputs/multi-select'
import { patchForm } from '../../../ajax'
import FlashAlert from '../../../components/flash-alert'

export default function EditPlayer({league, player, onClose, onUpdate}) {
  const positions = player.prefer_position ? player.prefer_position.split(', ').map(p => ({ value: p, label: p })) : ''
  const { register, control, handleSubmit, setValue, formState: { errors } } = useForm({
    defaultValues: {...player, prefer_position: positions }
  })
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState()
  const [countryCode, setCountryCode] = useState()

  const requiredMsg = 'Is required'
  const genderOptions = [['male', 'Male'], ['female', 'Female'], ['prefer not to say', 'Prefer not to say']]
  const skillLevelOptions = [['', 'Select'], [0, 'Beginner'], [1, 'Intermediate'], [2, 'Advanced'], [3, 'Expert']]
  const sizeOptions = [['', 'Select'], ['XS', 'XS'], ['S', 'S'], ['M', 'M'], ['L', 'L'], ['XL', 'XL'], ['XXL', 'XXL']]
  const positionOptions = ['Forward', 'Winger', 'Center Midfielder', 'Right / Left Back', 'Center Back', 'Goalie'].map(val => ({value: val, label: val}))
  const validateText = (value) => {
    if (!value.trim()) return requiredMsg
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    formData.append('member[player_attributes][id]', player.player_id)
    formData.append('member[player_attributes][first_name]', data.first_name.trim())
    formData.append('member[player_attributes][last_name]', data.last_name.trim())
    formData.append('member[player_attributes][gender]', data.gender)
    formData.append('member[player_attributes][email]', data.email)
    formData.append('member[player_attributes][phone]', data.phone)
    if (countryCode) formData.append('member[player_attributes][country_code]', countryCode)
    formData.append('member[player_attributes][birthday]', moment(new Date(data.birthday)).format('DD/MM/YYYY'))
    formData.append('member[player_attributes][skill_level]', data.skill_level)
    formData.append('member[player_attributes][prefer_position]', data.prefer_position ? data.prefer_position.map(v => v.label).join(', ') : '')
    formData.append('member[player_attributes][shirt_size]', data.shirt_size)
    return formData
  }

  const onSubmit = async (data) => {
    setLoading(true)
    const formData = prepareFormData(data)
    const response = await patchForm(`/admins/leagues/${league.id}/members/${player.id}.json`, formData)
    const json = await response.json()
    setLoading(false)
    if (json.alert) setAlert(json.alert)
    else onUpdate(json.member)
  }

  const onClickCancel = (e) => {
    e.preventDefault()
    onClose()
  }

  return <Modal container={document.body} backdrop='static' show={true} onHide={onClose} dialogClassName='edit-player-modal'>
    <Modal.Header closeButton>
      <Modal.Title>Edit Player</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className={'edit-player-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        { loading && <div className='animated-spinner'></div> }
        <div className='row'>
          <div className='col-xs-12 col-md-4'>
            <TextInput
              {...register('first_name', { required: requiredMsg, validate: validateText })}
              label='First Name'
              error={errors.first_name}
              onChange={e => setValue('first_name', e.target.value)}
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <TextInput
              {...register('last_name', { required: requiredMsg, validate: validateText })}
              label='Last Name'
              error={errors.last_name}
              onChange={e => setValue('last_name', e.target.value)}
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <SelectInput
              {...register('gender')}
              label='Gender'
              options={genderOptions}
              onChange={e => setValue('gender', e.target.value)}
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-xs-12 col-md-4'>
            <TextInput
              {...register('email', {
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid email address'
                } 
              })}
              label='Email'
              error={errors.email}
              onChange={e => setValue('email', e.target.value)}
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <PhoneInputWrapper
              {...register('phone', { required: requiredMsg })}
              label='Phone Number'
              error={errors.phone}
              defaultValue={player.phone}
              onChange={(p, c) => {
                setCountryCode(c)
                setValue('phone', p)
              }}
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <DateSelect name='birthday' control={control} label='Birthday' />
          </div>
        </div>

        <div className='row'>
          <div className='col-xs-12 col-md-4'>
            <SelectInput
              {...register('skill_level', { required: requiredMsg })}
              label='Skill Level'
              options={skillLevelOptions}
              error={errors.skill_level}
              onChange={e => setValue('skill_level', e.target.value)}
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <MultiSelect
              name='prefer_position'
              label='Preferred Position'
              required
              error={errors.prefer_position}
              options={positionOptions}
              control={control}
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <SelectInput
              {...register('shirt_size', { required: requiredMsg })}
              label='Shirt Size'
              options={sizeOptions}
              error={errors.shirt_size}
              onChange={e => setValue('shirt_size', e.target.value)}
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-xs-12 text-center player-buttons'>
            <button className='player-button button-back' onClick={onClickCancel}>Cancel</button>
            <button className='player-button button-save'>Save</button>
          </div>
        </div>
      </form>
    </Modal.Body>
  </Modal>
}
